import "./NotFound.css"
const Notfound = () => {
  return (
    <div className="notfound">
   <img className="w-100" src={'/images/404-status-code.png'} alt="" />
    </div>
  )
}

export default Notfound
